module.exports = __webpack_public_path__ + "img/white_hover.4777ea4c.png";